// ══════════════════════════════════════════════════════
// PeptideVault v6.5 — Supplement Regimen Versioning (BN19)
// ══════════════════════════════════════════════════════
var _rvSuppId = null

function setRVSuppId(id) { _rvSuppId = id; render() }

function renderRegimenVersionsTab() {
  var supps = (S.supplements || []).filter(function(s) { return (s.status || 'active') === 'active' })
  var versions = (S.regimenVersions || []).filter(function(v) { return !_rvSuppId || v.suppId === _rvSuppId })
  versions.sort(function(a, b) { return (b.effectiveDate || '').localeCompare(a.effectiveDate || '') })

  return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
    '<div class="row" style="margin-bottom:16px;flex-wrap:wrap;gap:8px;align-items:center">' +
      '<h2 style="font-size:20px;font-weight:700">Regimen History</h2><div class="spacer"></div>' +
      '<select class="form-input" style="width:auto;font-size:12px" onchange="setRVSuppId(this.value||null)">' +
        '<option value="">All Supplements</option>' +
        supps.map(function(s) { return '<option value="' + s.id + '"' + (_rvSuppId === s.id ? ' selected' : '') + '>' + esc(s.name) + '</option>' }).join('') +
      '</select>' +
      '<button class="btn btn-primary btn-sm" onclick="createRegimenSnapshot()">Save Current Regimen</button>' +
    '</div>' +
    (versions.length === 0 ? '<div class="card"><div class="empty-state" style="padding:48px"><div class="empty-icon">\uD83D\uDCCB</div><p>No regimen versions yet</p><span>Save your current supplement regimen to create a versioned snapshot you can compare later.</span></div></div>' :
      versions.map(function(v) {
        var supp = (S.supplements || []).find(function(s) { return s.id === v.suppId })
        return '<div class="card" style="margin-bottom:10px;padding:14px">' +
          '<div class="card-header" style="padding:0;margin-bottom:8px"><div><div class="card-title">' + esc(supp ? supp.name : v.suppId) + '</div>' +
          '<div style="font-size:12px;color:var(--text3)">Effective: ' + fmt(v.effectiveDate) + (v.notes ? ' \u00B7 ' + esc(v.notes) : '') + '</div></div>' +
          '<span class="badge">v' + ((S.regimenVersions || []).filter(function(rv) { return rv.suppId === v.suppId && rv.effectiveDate <= v.effectiveDate }).length) + '</span></div>' +
          (v.snapshot ? '<div style="font-size:12px;color:var(--text3)">' +
            Object.keys(v.snapshot).filter(function(k) { return k !== 'id' }).map(function(k) { return '<span style="margin-right:12px"><b>' + esc(k) + ':</b> ' + esc(String(v.snapshot[k] || '')) + '</span>' }).join('') +
          '</div>' : '') +
          (v.changes && Object.keys(v.changes).length > 0 ? '<div style="font-size:11px;color:var(--amber);margin-top:4px">Changes: ' + Object.keys(v.changes).map(function(k) { return k + ': ' + esc(String(v.changes[k])) }).join(', ') + '</div>' : '') +
        '</div>'
      }).join('')) +
  '</div>'
}

function createRegimenSnapshot() {
  var supps = (S.supplements || []).filter(function(s) { return (s.status || 'active') === 'active' })
  var today = fmtLD(new Date())
  supps.forEach(function(s) {
    var snapshot = { name: s.name, strength: s.strength, form: s.form, dailyServing: s.dailyServing, servingAM: s.servingAM, servingPM: s.servingPM, timeOfDay: s.timeOfDay, brand: s.brand }
    var prev = (S.regimenVersions || []).filter(function(v) { return v.suppId === s.id }).sort(function(a, b) { return b.effectiveDate.localeCompare(a.effectiveDate) })[0]
    var changes = {}
    if (prev && prev.snapshot) {
      Object.keys(snapshot).forEach(function(k) { if (String(snapshot[k]) !== String(prev.snapshot[k])) changes[k] = prev.snapshot[k] + ' \u2192 ' + snapshot[k] })
    }
    if (!prev || Object.keys(changes).length > 0) {
      S.regimenVersions.push({ id: uid(), suppId: s.id, effectiveDate: today, changes: changes, snapshot: snapshot, notes: '' })
    }
  })
  save(); showToast('Regimen snapshot saved'); render()
}

function getRegimenOnDate(dateStr) {
  var result = {}
  ;(S.supplements || []).forEach(function(s) {
    var versions = (S.regimenVersions || []).filter(function(v) { return v.suppId === s.id && v.effectiveDate <= dateStr })
    versions.sort(function(a, b) { return b.effectiveDate.localeCompare(a.effectiveDate) })
    result[s.id] = versions[0] ? versions[0].snapshot : { name: s.name, strength: s.strength, dailyServing: s.dailyServing }
  })
  return result
}

export { _rvSuppId, setRVSuppId, renderRegimenVersionsTab, createRegimenSnapshot, getRegimenOnDate }
